// src/components/Header.js
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { AuthContext } from "../context/AuthContext"; // Adjust the path as needed
import { formatDate, getCurrentTime } from "../constant";
import useAxios from "../common/hook/useAxios";
import {
  FaCircleCheck,
  FaCircleXmark,
  FaFlag,
  FaPrint,
  FaRegMessage,
} from "react-icons/fa6";
import { toast } from "react-toastify";
import { usePatientDemographic } from "../context/DempgraphicContext";
const Header = () => {
  const { user, logout } = useContext(AuthContext); // Access user and logout from context
  const { request } = useAxios();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { setPatientDemographics, patientDemographics } = usePatientDemographic()
  const patientId = searchParams.get("patientId") || "";
  const [checkinStatus, setCheckinStatus] = useState(0);
  const [totalCheckinCount, setTotalCheckinCount] = useState(0);
  const [lastCheckout, setLastCheckout] = useState("");
  const [totalDuration, setTotalDuration] = useState("00:00");
  const [duration, setDuration] = useState("00:00");
  const [firstCheckinTime, setFirstCheckinTime] = useState("");
  const [CheckOutTime, setCheckOutTime] = useState("");
  const [checkInStatusData, setCheckInStatusData] = useState("");
  const [checkOutStatus, setCheckOutStatus] = useState(false);
  // const [initialized, setInitialized] = useState(false);
  const [showClockModal, setShowClockModal] = useState(false);
  useEffect(() => {
    if (patientId) {
      getDM()
    }
  }, [patientId])
  const logoutUser = async () => {
    if (user) {
      const requestBody = {
        PracticeID: user?.PracticeID,
        UserID: user?.userId
      };
      try {
        await request(
          `${process.env.REACT_APP_LOGIN_API_URL}/Authentication/Logout?sInputJSON=${JSON.stringify(requestBody)}`,
          {
            method: "POST",
          },
        );
        toast.success("Logout Successful", { autoClose: 2000 });
        logout();
        navigate("/login");
      } catch (err) {
        toast.error("Error occurred while logging out", { autoClose: 3000 });
      }

    }
  };

  const fetchUserClockStatus = () => {
    setShowClockModal(true);
    setCheckOutStatus(false);

    const objInput = {
      UserID: user?.userId,
      isFromApp: 0,
      PracticeID: user?.PracticeID,
      DefaultTimeZoneOffSet: user?.DefaultTimeZoneOffSet,
    };

    // const myInput = JSON.stringify(objInput);
    const myInput = JSON.stringify({ objTimeSheet: objInput });
    const url = `${process.env.REACT_APP_TIMESHEET_URL}/TimeSheet/CheckUserCheckinStatus?sInputJSON=${myInput}`;

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status != 200) {
          console.log("response.status", response.status);
        } else return response.json();
      })
      .then((resData) => {
        const parsedData = JSON.parse(resData);
        // console.log("Duration of ", parsedData.Duration);

        setTotalCheckinCount(parsedData.TotalCheckinCount);
        setTotalDuration(parsedData.TotalDuration);
        setDuration(parsedData.Duration);
        setFirstCheckinTime(parsedData.FirstCheckinTime);
        setLastCheckout(
          parsedData.TotalCheckinCount == 0 ? "" : parsedData.LastCheckout,
        );
        setCheckinStatus(parsedData.CheckinStatus);
        setCheckInStatusData(parsedData);
      })
      .catch((error) => {
        console.error("API request failed", error);
      });
  };

  useEffect(() => {
    fetchUserClockStatus();
  }, [user]);

  const fetchUserClockIn = () => {
    const UserDetails = {
      UserID: user?.userId,
      Lattitude: 0.0,
      Longitude: 0.0,
      CheckinoutTime: getCurrentTime(),
      CheckinoutDate: formatDate(new Date()),
      isServerTime: 1,
      PracticeID: user?.PracticeID,
      DefaultTimeZoneOffSet: user?.DefaultTimeZoneOffSet,
    };

    var locString = JSON.stringify(
      JSON.stringify({ objTimeSheet: UserDetails }),
    );

    // console.log("input of" + CommonAPIConstants.GetUserClockIn, locString);

    const response = fetch(
      `${process.env.REACT_APP_TIMESHEET_URL}/TimeSheet/CheckinInUser`,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: locString,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        const parsedData = JSON.parse(data);
        setCheckinStatus(parsedData.CheckinStatus);
        setTotalDuration(parsedData.TotalDuration);
        setFirstCheckinTime(parsedData.FirstCheckinTime);

        setShowClockModal(false);
      })
      .catch((error) => {
        console.error("Error fetching CPT names:", error);
      });
  };
  const getDM = () => {
    request(
      `${process.env.REACT_APP_PATIENT_PORTAL_URL}/PatientDemography?PatientId=${patientId}`,
      {
        method: "GET",
      },
    )
      .then((data) => {
        const parsedData = JSON.parse(data);
        setPatientDemographics(parsedData)
      })
      .catch(() => {
        toast.error("Error occured while fetching demographic details", {
          autoClose: 3000,
        });
      });
  }

  const fetchUserClockOut = () => {
    var today = new Date();

    var date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();

    var time =
      today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

    const UserDetails = {
      UserID: user?.userId,
      Lattitude: 0.0,
      Longitude: 0.0,
      CheckinoutTime: getCurrentTime(),
      CheckinoutDate: formatDate(new Date()),
      isServerTime: 1,
      PracticeID: user?.PracticeID,
      DefaultTimeZoneOffSet: user?.DefaultTimeZoneOffSet,
    };

    var locString = JSON.stringify(
      JSON.stringify({ objTimeSheet: UserDetails }),
    );

    const response = fetch(
      `${process.env.REACT_APP_TIMESHEET_URL}/TimeSheet/CheckOutUsers`,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: locString,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        const parsedData = JSON.parse(data);
        //  setDuration(parsedData)
        setTotalDuration(parsedData[0].Duration);
        setFirstCheckinTime(parsedData[0].CheckinTime);
        setCheckOutTime(parsedData[0].CheckoutTime);
        setCheckinStatus(0);
        setCheckOutStatus(true);
      })
      .catch((error) => {
        console.error("Error fetching:", error);
      });
  };

  const handleCloseModals = () => {
    // Close all modals

    setShowClockModal(false);
    setCheckOutStatus(false);
  };

  const handlePrintForAll = (LastName, FirstName, DOB) => {
    const now = new Date();

    const date = now.toLocaleDateString("en-US"); // e.g., 6/9/2025
    const time = now.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    const dayName = now.toLocaleDateString("en-US", { weekday: "long" }); // e.g., Monday
    const curTime = `${date} (${dayName}) ; ${time}`;

    const printContainer = document.createElement("div"); // ✅ Create container
    document.body.appendChild(printContainer); // ✅ Append to body before printing

    const patientDiv = document.createElement("div");
    patientDiv.innerHTML = `
    <div style="font-family: 'Times New Roman'; font-size: 18px; padding: 10px;">
      <div style="transform:rotate(270deg); margin-top: 130px; margin-left: -110px;">
        ${LastName} ${FirstName} ; ${DOB}<br />${curTime}
      </div>
    </div>
  `;

    printContainer.appendChild(patientDiv);

    const printContent = printContainer.innerHTML;
    const newWindow = window.open("", "_blank");
    newWindow.document.write(`
    <html>
    <head>
      <style>
        @media print {
          @page {
            margin: 0;
          }
          body {
            font-family: 'Times New Roman', serif;
            margin: 0;
          }
          .page-break {
            page-break-after: always;
          }
        }
      </style>
    </head>
    <body>
      ${printContent}
    </body>
    </html>
  `);

    newWindow.document.close();
    newWindow.print();
    newWindow.onafterprint = () => newWindow.close();

    document.body.removeChild(printContainer); // ✅ Cleanup
  };

  // console.log(user, "res");
  const today = new Date();
  const formattedDate = `${today.toLocaleDateString("en-US")}`;
  const formattedDay = `${today.toLocaleDateString("en-US", {
    weekday: "long",
  })}`;

  return (
    <>
      {patientId ? <div className="bg-blue-600 p-2">
        <div className="flex flex-row items-center justify-between w-full py-2 px-2 bg-white rounded-2xl">
          <div className="header-pat-text flex flex-row gap-2">
            <div className="bg-lightGreen">
              {user?.practiceFullId}
            </div>{" "}
            |{" "}
            <div className="bg-gray-200 p-0.5">
              {user?.UserName}
            </div>
          </div>
          <div className="flex flex-row items-center  justify-center gap-2 header-pat-text">
            <div
              className={`header-pat-text ${patientDemographics?.isDischarge === 1
                ? "bg-red-400"
                : "bg-lightGreen"
                }`}
            >
              {patientDemographics?.MRN}
            </div> |
            <div
              className={`header-pat-text ${patientDemographics?.isDischarge === 1
                ? "bg-red-400"
                : "bg-lightGreen"
                }`}
            >
              {patientDemographics?.LastName}, {patientDemographics?.FirstName}{" "}
            </div>{" "}
            |{" "}
            <div
              className={`header-pat-text ${patientDemographics?.isDischarge === 1
                ? "bg-red-400"
                : "bg-lightGreen"
                }`}
            >
              {" "}
              {patientDemographics?.DOB}
            </div>{" "}
            |
            <div
              className={`header-pat-text ${patientDemographics?.isDischarge === 1
                ? "bg-red-400"
                : "bg-lightGreen"
                }`}
            >
              {" "}
              {patientDemographics?.Age} Years{" "}
            </div>{" "}
            |{" "}
            <div
              className={`header-pat-text ${patientDemographics?.isDischarge === 1
                ? "bg-red-400"
                : "bg-lightGreen"
                }`}
            >
              {" "}
              {patientDemographics?.Sex === "1" && "Male"}
              {patientDemographics?.Sex === "2" && "Female"}
            </div>
            |{" "}
            <FaPrint
              className="text-2xl bg-lightGreen cursor-pointer"
              onClick={() =>
                handlePrintForAll(
                  patientDemographics?.LastName,
                  patientDemographics?.FirstName,
                  patientDemographics?.DOB
                )
              }
            />{" "}
            | <button onClick={() =>
              handlePrintForAll(
                patientDemographics?.LastName,
                patientDemographics?.FirstName,
                patientDemographics?.DOB
              )
            } className="butu">Print ID</button> |{" "}
            <FaFlag className="text-2xl" />
            <FaRegMessage className="text-2xl text-defOrange" />
            <div className="bg-lightGreen">{formattedDay} </div>
            <div className="bg-lightGreen">,</div>
            <div className="bg-lightGreen">{formattedDate}</div>
          </div>
          <div className="header-logout">
            <button
              onClick={logoutUser}
            >
              Log Out
            </button>
          </div>
        </div>
      </div> :
        <header className="bg-[#cccc] text-black font-medium px-3 py-2">
          <nav>
            <ul className="">
              {user && (
                <div className="">
                  <div className="flex flex-row items-center justify-between">
                    <li>Welcome {user?.practiceFullId}</li>{" "}
                    <div>
                      {user?.userFullName}
                      {checkinStatus == 0 ? (
                        <button
                          className="clock-btn"
                          onClick={fetchUserClockStatus}
                        >
                          Clock-in
                        </button>
                      ) : (
                        <button className="initial" onClick={fetchUserClockStatus}>
                          {checkinStatus && <div>Clock-in: {totalDuration}</div>}
                        </button>
                      )}
                    </div>
                    <div>
                      {user ? (
                        <li>
                          <button
                            onClick={logoutUser}
                            className="bg-transparent border border-black text-black hover:border-white hover:text-white p-2 rounded hover:bg-gray-700 focus:outline-none"
                          >
                            Logout
                          </button>
                        </li>
                      ) : location.pathname !== "/login" ? (
                        <li>
                          <Link
                            to="/login"
                            className="text-white hover:text-gray-400"
                          >
                            Login
                          </Link>
                        </li>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className="nav-container">
                    {location.pathname === "/" && showClockModal && (
                      <>
                        <div className="msgcheckinPopUp text-center">
                          <FaCircleXmark
                            style={{ color: "brown", float: "right" }}
                            onClick={handleCloseModals}
                          />
                          <label className="checkinoutcurdate mt-4 ">
                            {formatDate(new Date())} {getCurrentTime()}
                          </label>{" "}
                          <br></br>
                          <label className="checkinpopupcnfmsg">
                            {checkinStatus == 0
                              ? "You are not checked in!"
                              : "You are checked in!"}
                          </label>
                          <div className="checkinpopupmsg ">
                            <div className="flex flex-row items-center justify-around">
                              {checkinStatus == 0 ? (
                                <FaCircleXmark className="Usercheckout" />
                              ) : (
                                <FaCircleCheck className="Usercheckin" />
                              )}
                              <div>
                                <label>{firstCheckinTime}</label>
                                <br />

                                <div>
                                  <label style={{ marginLeft: "20px" }}>
                                    {totalDuration}
                                  </label>
                                </div>
                              </div>
                            </div>

                            {checkinStatus == 0 ? (
                              <button
                                className="clock-btn"
                                onClick={fetchUserClockIn}
                              >
                                Clock-in
                              </button>
                            ) : (
                              <button
                                className="clock-btn"
                                onClick={fetchUserClockOut}
                              >
                                Clock-out
                              </button>
                            )}
                          </div>
                        </div>

                        {checkOutStatus && (
                          <div className="msgcheckinPopUp text-center">
                            <FaCircleXmark
                              style={{ color: "brown", float: "right" }}
                              onClick={handleCloseModals}
                            />
                            <label className="checkinoutcurdate mt-4">
                              {formatDate(new Date())} {getCurrentTime()}
                            </label>{" "}
                            <br></br>
                            <label className="checkinpopupcnfmsg">
                              You are checked Out!
                            </label>
                            <div className="checkinpopupmsg">
                              <div className="flex items-center justify-around gap-2">
                                <FaCircleXmark className="Usercheckout" />

                                <div>
                                  <label style={{ marginLeft: "10px" }}>
                                    Clock-in Time:{firstCheckinTime}
                                  </label>
                                  <br />

                                  <div>
                                    <label
                                      style={{
                                        marginLeft: "0px",
                                        fontSize: "2rem",
                                      }}
                                    >
                                      Clock-out Time:{CheckOutTime}
                                    </label>
                                  </div>

                                  <div>
                                    <label>{totalDuration}</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
              {/* {location.pathname !== "/" && user ? (
            <div>
              <li>
                <Link to="/" className="text-white hover:text-gray-400">
                  Home
                </Link>
              </li>
            </div>
          ) : (
            <div></div>
          )} */}
            </ul>
          </nav>
          {/* <Modal
        isOpen={isOpen}
        onRequestClose={toggleMenu}
        className={`absolute flex flex-col min-w-max items-center justify-center p-4 w-48 bg-bg-lightGreen-400 shadow-lg rounded-lg transition-transform duration-300 ease-in-out transform ${
          isOpen ? "translate-y-0 opacity-100" : "-translate-y-4 opacity-0"
        }`}
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 transition-opacity flex flex-col items-center justify-center"
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
      >
        <div className="bg-bg-lightGreen-400">
          <div className="flex items-end justify-end">
            <FaXmark onClick={toggleMenu} />
          </div>
          <div className="bg-red-900 text-white p-2 px-36 mt-1 text-2xl">
            {formatDate(new Date())} {getCurrentTime()}
          </div>
          <p className="my-4 text-center text-2xl">
            {firstClockInData?.CheckinStatus === 0
              ? "You are not checked in"
              : "You are checked in"}
          </p>
          <div className="bg-gray-300 grid grid-cols-4 py-2">
            {firstClockInData?.CheckinStatus === 0 ? (
              <FaCircleXmark
                style={{ color: "#d23747" }}
                className="text-6xl ml-3"
              />
            ) : (
              <FaCircleRight className="text-6xl ml-3" />
            )}

            <div className="col-span-3 text-xl">
              {firstClockInData?.LastCheckout} <br></br>{" "}
              {firstClockInData?.Duration != null &&
              firstClockInData?.Duration !== "" ? (
                (() => {
                  const timeParts = firstClockInData?.Duration.split(":");
                  if (timeParts.length === 3) {
                    return `${timeParts[0]}:${timeParts[1]}`; // Show only hours and minutes
                  } else if (timeParts.length === 2) {
                    return `${timeParts[0]}:${timeParts[1]}`;
                  }
                  return timeParts[0];
                })()
              ) : (
                <span>Invalid Duration</span>
              )}
            </div>
          </div>
          <div className="text-center">
            <button
              className={`px-6 py-3 text-sm rounded-lg mt-4 bg-orange text-white`}
              onClick={handleClockIn}
            >
              Clock In
            </button>
          </div>
        </div>
      </Modal> */}

          {/* <Modal
        isOpen={isClockOut}
        onRequestClose={toggleMenu}
        className={`absolute flex flex-col min-w-max items-center justify-center p-4 w-48 bg-bg-lightGreen-400 shadow-lg rounded-lg transition-transform duration-300 ease-in-out transform ${
          isOpen ? "translate-y-0 opacity-100" : "-translate-y-4 opacity-0"
        }`}
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 transition-opacity flex flex-col items-center justify-center"
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
      >
        <div className="bg-bg-lightGreen-400">
          <div className="flex items-end justify-end">
            <FaXmark onClick={toggleMenu} />
          </div>
          <div className="bg-red-900 text-white p-2 px-36 mt-1 text-2xl">
            {formatDate(new Date())} {getCurrentTime()}
          </div>
          <p className="my-4 text-center text-2xl">
          
            You are checked in
          </p>
          <div className="bg-gray-300 grid grid-cols-4 py-2">
            <FaCircleRight
              style={{ color: "#d23747" }}
              className="text-6xl ml-3"
            />

            <div className="col-span-3 text-xl">
              {firstClockInData?.LastCheckout} <br></br>{" "}
              {firstClockInData?.Duration}
            </div>
          </div>
          <div className="text-center">
            <button
              className={`px-6 py-3 text-sm rounded-lg mt-4 bg-orange text-white`}
              onClick={handleClockOut}
            >
              Clock Out
            </button>
          </div>
        </div>
      </Modal> */}
        </header>}
    </>
  );
};

export default Header;
